import { styled } from '@mui/material/styles';
import { Box, BoxProps } from 'shared/mui/Box';

export type FilterBarActionsProps = BoxProps;

export const FilterBarActions: React.FC<FilterBarActionsProps> = styled(Box)({
  display: 'flex',
  gap: '16px',
  '& button': {
    height: '40px',
  },
});
